import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './authentication/auth.guard';
import { AuthCallbackComponent } from './authentication/auth-callback.component';
import { LogoutCallbackComponent } from './authentication/logout-callback.component';

const routes: Routes = [
    { path: '', redirectTo: '/projects', pathMatch: 'full' },
    { path: 'authenticate', component: AuthCallbackComponent },
    { path: 'logout', component: LogoutCallbackComponent },
    { path: 'projects', loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule), canActivate: [AuthGuard], canLoad: [AuthGuard]},
    { path: 'charts', redirectTo: '/all-charts' },
    { path: 'all-charts', loadChildren: () => import('./all-charts/all-charts.module').then(m => m.AllChartsModule), canActivate: [AuthGuard], canLoad: [AuthGuard] },
    { path: 'configurations', loadChildren: () => import('./configurations/configurations.module').then(m => m.ConfigurationsModule), canActivate: [AuthGuard], canLoad: [AuthGuard] },
    { path: 'permissions', loadChildren: () => import('./permissions/permissions.module').then(m => m.ConfigurationsModule), canActivate: [AuthGuard], canLoad: [AuthGuard] },
    { path: 'account-configuration', loadChildren: () => import ("./account-configuration/account-configuration.module").then(m => m.AccountConfigurationModule), canActivate: [AuthGuard], canLoad: [AuthGuard]}
  ]

@NgModule({
    declarations: [
    ],
    imports: [
        RouterModule.forRoot(routes, {})
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class AppRoutingModule {}
